import { ActionTypes } from "../constants/action-types";

const initialState = {
 judges: [],
  totaljudges: 0,
};

export const FetchJudges = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_JUDGES_SUCCESS:
      return {
        ...state,
        judges: action.payload,
        totaljudges: action.payload.length,
      };

    default:
      return state;
  }
};

export default FetchJudges;
